export const validateVendorRegistration = (formData) => {
  const errors = {};

  // Validate Vendor Name
  if (!formData.businessName || formData.businessName.trim().length < 1) {
    errors.businessName = "Business name is required.";
  } else if (formData.businessName.length > 50) {
    errors.businessName = "Business name cannot exceed 50 characters.";
  }

  // Validate Contact Name
  if (!formData.contactName || formData.contactName.trim().length < 1) {
    errors.contactName = "Contact person name is required.";
  } else if (formData.contactName.length > 50) {
    errors.contactName = "Contact person name cannot exceed 50 characters.";
  }

  // Validate Email Address

  // Validate Phone Number
  if (!formData.phoneNo || formData.phoneNo.trim().length < 1) {
    errors.phoneNo = "Contact number is required.";
  } else if (!/^\d{1,15}$/.test(formData.phoneNo)) {
    errors.phoneNo =
      "Contact number must be a valid numeric value with up to 15 digits.";
  }

  // Validate Password
  if (!formData.password || formData.password.trim().length < 6) {
    errors.password = "Password must be at least 6 characters long.";
  } else if (
    !/(?=.*\d)(?=.*[@#$%^&+=_])(?=.*[A-Za-z])/.test(formData.password)
  ) {
    errors.password =
      "Password must contain at least one letter, one number, and one special character.";
  } else if (formData.password.length > 30) {
    errors.password = "Password cannot exceed 30 characters.";
  }

  return errors;
};
